<div fxLayoutAlign="center start" class="form-container">
    <form>
        <div class="title">Passwort zurücksetzen</div>
        <div class="input-group">
            <label for="password">Passwort</label><br>
            <input [(ngModel)]="password" id="password" name="password" type="password" class="login"
                   placeholder="Passwort eingeben"/>
        </div>
        <div class="input-group">
            <label for="password2">Passwort bestätigen</label><br>
            <input [(ngModel)]="password2" id="password2" name="password2" type="password" class="login"
                   placeholder="Passwort bestätigen"/>
        </div>
        <div (click)="login()" class="action">
            <button [disabled]="!canLogin()">Speichern</button>
        </div>
    </form>
</div>
